import { DriverOfYourCarForm } from "./Form";
import useDriverOfYourCar from "./hooks/useDriverOfYourCar";

export const DriverOfYourCar = () => {
  const props = useDriverOfYourCar();
  return <DriverOfYourCarForm {...props} />;
};

export default DriverOfYourCar;
